import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { UpcomingAppointment } from "@/Common/Models/Appointments/UpcomingAppointment";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

interface IPatientBannerUpcomingAppointment {
    appointment: UpcomingAppointment;
    label: string
}

export function PatientBannerUpcomingAppointment(props: IPatientBannerUpcomingAppointment): JSX.Element {
    const { getText } = useTranslation();

    if (!props.appointment) {
        return (
            <li className="patient-banner-appointment">
                <span className="myle-icon-16 cal-empty" />
                <span>{props.label} :</span>
                <span>N/A</span>
            </li>
        );
    }
    let today = props.appointment.HasAppointmentToday === true ? getText("TodayLabel") + "." : "";

    let appDateDisplay = "";
    if (props.appointment.DateTime) {
        if (today)
            today = `${today.substring(0, 3)}+"`;

        appDateDisplay = LuxonDateTimeParser.parse(props.appointment.DateTime).toFormat("yyyy-MM-dd HH:mm a");
    }

    let appointmentDescription = props.appointment.Subject ?? "";
    if (props.appointment.ServiceDefinitionId) {
        const serviceDefinitionName = cacheStore.GetServiceDefinitionName(props.appointment.ServiceDefinitionId);
        appointmentDescription = `${appointmentDescription} ${serviceDefinitionName ? `(${serviceDefinitionName})` : ""}`;
    }

    const appointmentProvider = cacheStore.getServiceProvidersName(props.appointment.EmployeeContactFacetIds);
    let appointmentTextRow = `${today ?? ""} ${appDateDisplay ?? ""} ${appointmentDescription ?? ""}`;

    if (appointmentProvider)
        appointmentTextRow = `${appointmentTextRow} (${appointmentProvider})`;

    return (
        <li className="patient-banner-appointment">
            <span className="myle-icon-16 cal-empty" />
            <span>{props.label} :</span>
            <span title={appointmentTextRow}> {appointmentTextRow}</span>
        </li>
    );
}
